import React, { useMemo, useState } from 'react';
import './OtpInput.css'
import { RE_DIGIT } from '../../../App';

import { AiFillEye, AiFillEyeInvisible, } from "react-icons/ai";

const OtpInput = ({ value, valueLength, onChange }) => {
    const [visibleCondition, setVisibleCondition] = useState(false);

    const changeCondition = (() => {    // pin check
        setVisibleCondition(!visibleCondition);
    })

    const valueItems = useMemo(() => {
        const valueArray = value?.split("");
        const items = [];

        for (let i = 0; i < valueLength; i++) {
            const char = valueArray[i];

            if (RE_DIGIT.test(char)) {
                items.push(char);
            } else {
                items.push("");
            }
        }

        return items;
    }, [value, valueLength]);



    const inputOnChange = (e, index) => {
        const target = e.target;
        let targetValue = target.value.trim();
        const isTargetValueDigit = RE_DIGIT.test(targetValue);

        if (!isTargetValueDigit && targetValue !== "") {
            return;
        }

        targetValue = isTargetValueDigit ? targetValue : " ";

        const targetValueLength = targetValue.length;

        if (targetValueLength === 1) {
            const newValue =
                value.substring(0, index) + targetValue + value.substring(index + 1);

            onChange(newValue);

            if (!isTargetValueDigit) {
                return;
            }

            const nextElementSibling =
                target.nextElementSibling;

            if (nextElementSibling) {
                nextElementSibling.focus();
            }
        } else if (targetValueLength === valueLength) {
            onChange(targetValue);

            target.blur();
        }
    };


    const inputOnKeyDown = (e) => {
        const target = e.target;

        if (e.key !== "Backspace" || target.value !== "") {
            return;
        }

        const previousElementSibling = target.previousElementSibling;

        if (previousElementSibling) {
            previousElementSibling.focus();
        }
    };

    return (
        <div className="d-flex justify-content-between align-items-center">
            <div className="otp-group">
                {valueItems?.map((digit, index) => (
                    <input
                        key={index}
                        type={(visibleCondition === true) ? "text" : "password"}
                        inputMode="numeric"
                        autoComplete="one-time-code"
                        pattern="\d{1}"
                        maxLength={valueLength}
                        className="otp-input"
                        value={digit}
                        onChange={(e) => inputOnChange(e, index)}
                        onKeyDown={inputOnKeyDown}
                    />
                ))}
            </div>
            <span onClick={changeCondition} className="ps-1 mt-1 pointer">
                {
                    visibleCondition ? <AiFillEye /> : <AiFillEyeInvisible />
                }
            </span>
        </div>
    );
};

export default OtpInput;